import { useEffect, useState } from 'react'

import { useAppSelector } from '../../../../tradebuilder-v2/store/hooks'
import { useActions } from '../../../../tradebuilder-v2/store/use-actions'
import { actions as submitActions } from '../state/submit-slice'
import TradeSubmitStateless from '../templates/trade-submit-stateless'

const TradeSubmit = () => {
  const builderState = useAppSelector(state => state.builder)
  const state = useAppSelector(state => state.submit)
  const actions = useActions(submitActions)
  const [isLoading, setIsLoading] = useState<boolean>(true)

  useEffect(() => {
    setIsLoading(true)
    actions.reset()
    actions.setEvents(builderState.approvalEvents)
  }, [actions, builderState.approvalEvents])
  useEffect(() => {
    setIsLoading(true)
  }, [builderState.selectedAccountId])
  useEffect(() => {
    setIsLoading(false)
  }, [state])

  if (!isLoading) {
    return <TradeSubmitStateless key={builderState.accountId} state={state} />
  }

  return null
}

export default TradeSubmit
